import { ReactNode } from "react";
import "@/styles/app.css";
import { useAppSurface } from "@/hooks/useAppSurface";

/** Loads app tokens and marks the document so portals inherit them. */
export function AppSurface({ children }: { children: ReactNode }) {
  useAppSurface();
  return <>{children}</>;
}
